import { WRAPPER_TYPES, } from '../redux/core/wrapperContext/wrapperContextSlice.js';
export const INITIAL_TRACKING_DELAY = 1000;
export const INTERVAL_TIMELAP = 100;
export var Method;
(function (Method) {
    Method["LINK"] = "link";
    Method["VIEW"] = "view";
})(Method || (Method = {}));
export var Action;
(function (Action) {
    Action["CLICK"] = "click";
    Action["ERROR"] = "error";
    Action["VISIBLE"] = "visible";
    Action["SUCCESS"] = "success";
    Action["NOT_VISIBLE"] = "notVisible";
})(Action || (Action = {}));
export const EventName = {
    CLICK: ['buttonClick'],
    ERROR: ['formError'],
};
export var Error;
(function (Error) {
    Error["FORM_FIELD"] = "formField";
    Error["FORM_VALIDATION"] = "formValidation";
})(Error || (Error = {}));
export const NO_VALUE = 'noValue';
export const pageLoginSources = [
    'RegistrationPage',
    'LoginPage',
    'resetPasswordPage',
];
/**
 * Maps two-step form types (from activeView) to tracking component states
 */
export const getTwoStepTrackingComponentState = (activeView, lastLoginMethod) => {
    const viewToComponentState = {
        twoStepLogin: 'loginForm',
        twoStepRegistration: 'registerForm',
        twoStepAccountIdentifier: 'emailVerificationForm',
        twoStepAppleUpdateEmail: 'postAppleLoginAddYourEmailForm',
        twoStepPasswordlessConfirmation: 'passwordlessCheckInboxOneTimeLinkSent',
        twoStepResetPassword: 'resetPasswordEnterEmailForm',
        twoStepResetPasswordSuccess: 'resetPasswordAttempted',
        twoStepReturning: lastLoginMethod === 'email'
            ? 'recommendedLoginFormEmail'
            : 'recommendedLoginFormSocial',
    };
    return activeView ? viewToComponentState[activeView] : undefined;
};
export const getComponentTrackingNames = (navigationContext, formType) => {
    const componentNames = {
        modal: {
            login: 'candidateLoginModal',
            registration: 'candidateRegistrationModal',
            resetPassword: 'resetPasswordModal',
            registrationSuccess: 'postRegistrationProfileCreatedWelcomeModal',
            basicTwoStep: 'candidateLoginRegisterModal',
            fullscreenTwoStep: 'candidateLoginRegisterModal',
            linkedInImportProfile: 'linkedinImportProfileModal',
        },
        stepModal: {
            twoStepAccountIdentifier: 'candidateLoginRegisterModal',
            twoStepLogin: 'candidateLoginRegisterModal',
            twoStepRegistration: 'candidateLoginRegisterModal',
            twoStepResetPassword: 'candidateLoginRegisterModal',
            twoStepResetPasswordSuccess: 'candidateLoginRegisterModal',
            twoStepCvUpload: 'candidateLoginRegisterModal',
            twoStepAppleUpdateEmail: 'candidateLoginRegisterModal',
            twoStepPasswordlessConfirmation: 'candidateLoginRegisterModal',
            twoStepReturning: 'candidateLoginRegisterModal',
        },
        page: {
            login: 'candidateLoginPage',
            registration: 'candidateRegistrationPage',
            resetPassword: 'resetPasswordPage',
            registrationSuccess: 'accountCreationSuccessPage',
            googleSuccess: 'googleAuthRedirect',
            passwordlessInvalidForm: 'passwordlessLinkResendEmailFormPage',
            passwordlessSuccess: 'passwordlessAuthRedirect',
            linkedInResponsePage: 'linkedinAuthRedirect',
        },
        inlineForm: {
            basicTwoStep: 'candidateLoginRegisterModal',
            fullscreenTwoStep: 'candidateLoginRegisterModal',
        },
    };
    return (componentNames[navigationContext]?.[formType] || 'unknownComponentName');
};
export const isInTwoStepWrapper = (activeWrapper) => activeWrapper === WRAPPER_TYPES.STEP_MODAL;
//# sourceMappingURL=constants.js.map